import { Text } from '@shared/components';
import { RateLogo } from '@shared/components/money-form/components/RateLogo';
import { RatingMethod } from '@shared/generated/graphql';
import useMovement from '@shared/graphql/hooks/movements/useMovement';
import { CarrierRate } from '@shared/types/quote';
import { sumCarrierRate } from '@shared/utils/rates/rates';
import { isNil } from 'lodash';

type MovementLoadboardRatesProps = {
  movementId: string;
};
export const MovementLoadboardRates = ({
  movementId,
}: MovementLoadboardRatesProps) => {
  const { movement } = useMovement({ id: movementId, pollInterval: 5000 });

  if (isNil(movement)) return null;

  const nonDirectOffers = movement.carrierRates.filter(
    (r) => r.ratingMethod !== RatingMethod.DIRECT_OFFER
  );

  const newestOfEachType: Map<RatingMethod, CarrierRate> = new Map();
  nonDirectOffers.forEach((offer) => {
    const existing = newestOfEachType.get(offer.ratingMethod);
    if (!existing || new Date(offer.createdAt) > new Date(existing.createdAt)) {
      newestOfEachType.set(offer.ratingMethod, offer);
    }
  });

  const sortedRates = Array.from(newestOfEachType.values()).sort((a, b) => {
    return b.ratingMethod.localeCompare(a.ratingMethod);
  });

  const rates =
    sortedRates.length === 0
      ? null
      : sortedRates.map((r) => <LoadboardRateCard key={r.id} rate={r} />);

  return (
    <div className="flex flex-col gap-3">
      <Text type="body-sm" className="text-gray-700">
        Loadboard Rates
      </Text>
      <div className="flex flex-col gap-2">{rates}</div>
    </div>
  );
};

const LoadboardRateCard = ({ rate }: { rate: CarrierRate }) => {
  const totalRate = sumCarrierRate(rate);
  return (
    <div className="mb-1 flex justify-between">
      <RateLogo rateMethod={rate.ratingMethod} />
      <Text type="body-sm" isHeavy className="font-medium text-gray-900">
        ${totalRate.toFixed(2)}
      </Text>
    </div>
  );
};
